export default __webpack_public_path__ + "static/media/step2.c0b7eb7e.png";